/* FSG product form: maps Color + Pack picks to a variant,
   updates price / SKU / stock, guards unavailable combos.
   Mirrors the sample-site behavior on real Shopify data. */
(function () {
  const root = document.querySelector("[data-product-form]");
  if (!root) return;

  const variants = JSON.parse(root.parentElement.querySelector("[data-variants-json]")?.textContent
    || document.querySelector("[data-variants-json]").textContent);

  const money = (cents) => "$" + (cents / 100).toFixed(2);

  const state = {
    option1: root.querySelector('[data-option-index="1"] .active')?.dataset.value || variants[0].option1,
    option2: root.querySelector('[data-option-index="2"] .active')?.dataset.value || variants[0].option2,
    qty: 1
  };

  const els = {
    id: root.querySelector("[data-variant-id]"),
    price: root.querySelector("[data-price]"),
    sku: root.querySelector("[data-sku]"),
    stock: root.querySelector("[data-stock]"),
    pickedColor: root.querySelector("[data-picked-color]"),
    add: root.querySelector("[data-add-btn]"),
    qtyInput: root.querySelector("[data-qty]")
  };

  function findVariant() {
    return variants.find(v => v.option1 === state.option1 && (!state.option2 || v.option2 === state.option2));
  }

  function packInfo(packValue) {
    const v = variants.find(x => x.option1 === state.option1 && x.option2 === packValue);
    if (!v) return "";
    const caseMatch = packValue.match(/(\d+)/);
    const n = caseMatch ? parseInt(caseMatch[1], 10) : 1;
    return n > 1
      ? money(v.price) + " (" + money(Math.round(v.price / n)) + " ea)"
      : money(v.price);
  }

  function render() {
    const v = findVariant();
    if (!v) return;
    els.id.value = v.id;
    if (els.sku) els.sku.textContent = v.sku || "";
    if (els.pickedColor) els.pickedColor.textContent = state.option1;
    if (els.price) {
      const caseMatch = (state.option2 || "").match(/(\d+)/);
      const n = caseMatch ? parseInt(caseMatch[1], 10) : 1;
      els.price.innerHTML = n > 1
        ? money(v.price) + ' <span class="unit">(' + money(Math.round(v.price / n)) + " per cartridge)</span>"
        : money(v.price);
    }
    if (els.stock) {
      els.stock.textContent = v.available ? "✓ In stock — ships in 1 business day" : "Currently out of stock";
      els.stock.style.color = v.available ? "" : "#a33";
    }
    if (els.add) els.add.disabled = !v.available;
    root.querySelectorAll("[data-pack-meta]").forEach(el => {
      el.textContent = packInfo(el.dataset.packMeta);
    });
  }

  root.querySelectorAll('[data-option-index="1"] .swatch-pick').forEach(btn => {
    btn.addEventListener("click", () => {
      state.option1 = btn.dataset.value;
      root.querySelectorAll('[data-option-index="1"] .swatch-pick').forEach(b => b.classList.toggle("active", b === btn));
      render();
    });
  });
  root.querySelectorAll('[data-option-index="2"] .pack-btn').forEach(btn => {
    btn.addEventListener("click", () => {
      state.option2 = btn.dataset.value;
      root.querySelectorAll('[data-option-index="2"] .pack-btn').forEach(b => b.classList.toggle("active", b === btn));
      render();
    });
  });

  const setQty = q => {
    state.qty = Math.max(1, q);
    els.qtyInput.value = state.qty;
  };
  root.querySelector("[data-qty-dec]")?.addEventListener("click", () => setQty(state.qty - 1));
  root.querySelector("[data-qty-inc]")?.addEventListener("click", () => setQty(state.qty + 1));

  render();
})();
